import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { NAV_ANCHORS } from "./content";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo wordmark="Optics Software" />
          <p className="text-sm text-zinc-500 mt-4 leading-relaxed">
            AI demand forecasting, made for cafés.
          </p>
        </div>
        <div>
          <div className="overline-label text-zinc-400">Product</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV_ANCHORS.map((a) => (
              <li key={a.href}>
                <a href={a.href} className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  {a.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="overline-label text-zinc-400">App</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/login" className="text-zinc-600 hover:text-zinc-900 transition-colors">Sign in</Link>
            </li>
            <li>
              <Link to="/login" className="text-zinc-600 hover:text-zinc-900 transition-colors">Create an account</Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline-label text-zinc-400">Legal</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/terms" className="text-zinc-600 hover:text-zinc-900 transition-colors">Terms</Link>
            </li>
            <li>
              <Link to="/privacy" className="text-zinc-600 hover:text-zinc-900 transition-colors">Privacy</Link>
            </li>
            <li>
              <Link to="/refunds" className="text-zinc-600 hover:text-zinc-900 transition-colors">Refunds</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-100">
        <div className="max-w-6xl mx-auto px-6 py-6 text-xs text-zinc-400 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Optics Software. All rights reserved.</span>
          <span>Prices in NZD · Cancel anytime</span>
        </div>
      </div>
    </footer>
  );
}
